"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Button_1 = __importDefault(require("@material-ui/core/Button"));

var Grid_1 = __importDefault(require("@material-ui/core/Grid"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importStar(require("react"));

var md_1 = require("react-icons/md");

var constants_1 = require("../../../constants");

var SideBar_1 = __importDefault(require("../SideBar"));

require("./style.scss");
/**
* MerryGoRound Moment to interactively visualize works and publications.
*/


var MerryGoRoundMoment = function MerryGoRoundMoment(props) {
  var children = props.children,
      sideBarContent = props.sideBarContent,
      style = props.style;

  var _a = (0, react_1.useState)(undefined),
      currentChild = _a[0],
      setCurrentChild = _a[1];

  var _b = (0, react_1.useState)(false),
      sidebar = _b[0],
      setSidebar = _b[1];

  var rootRef = (0, react_1.useRef)(null);
  var figureRef = (0, react_1.useRef)(null);
  var childCount = children.length;
  var withNav = childCount > 2;

  var handleCloseSidebar = function handleCloseSidebar() {
    return setSidebar(false);
  };

  var handleSelectChild = function handleSelectChild(child) {
    return function () {
      setCurrentChild(child);
      setSidebar(true);
    };
  };

  var loadMerryGoRound = function loadMerryGoRound() {
    var root = rootRef.current;
    var figure = figureRef.current;
    if (!root || !figure) return;
    var nextNavigator = root.querySelector('.merry-go-round-navigate-next');
    var prevNavigator = root.querySelector('.merry-go-round-navigate-prev');
    var childrenNodes = figure.children;
    var gap = 80;
    var bfc = ('bfc' in root.dataset);
    var theta = 2 * Math.PI / childCount;
    var currImage = 0;

    var rotateCarousel = function rotateCarousel(imageIndex) {
      figure.style.transform = "rotateY(" + imageIndex * -theta + "rad)";
    };

    var setupCarousel = function setupCarousel(childIndex, childWidth) {
      var apothem = childWidth / (2 * Math.tan(Math.PI / childCount));
      var transformOrigin = "50% 50% " + -apothem + "px";
      figure.style.transformOrigin = transformOrigin;
      Array.from(childrenNodes).forEach(function (_, index) {
        var childStyle = childrenNodes[index].style;
        childStyle.padding = gap + "px";
        childStyle.transformOrigin = transformOrigin;
        childStyle.transform = "rotateY(" + index * theta + "rad)";

        if (bfc) {
          childStyle.backfaceVisibility = 'hidden';
        }
      });
      rotateCarousel(childIndex);
    };

    var setupNavigation = function setupNavigation() {
      nextNavigator === null || nextNavigator === void 0 ? void 0 : nextNavigator.addEventListener('click', function (e) {
        e.stopPropagation();
        currImage += 1;
        rotateCarousel(currImage);
      }, true);
      prevNavigator === null || prevNavigator === void 0 ? void 0 : prevNavigator.addEventListener('click', function (e) {
        e.stopPropagation();
        currImage -= 1;
        rotateCarousel(currImage);
      }, true);
    };

    var getChildWidth = function getChildWidth() {
      return parseFloat(getComputedStyle(childrenNodes[0]).width);
    };

    setupCarousel(currImage, getChildWidth());
    window.addEventListener('resize', function () {
      setupCarousel(currImage, getChildWidth());
    });
    setupNavigation();
  };

  (0, react_1.useEffect)(function () {
    if (withNav) {
      loadMerryGoRound();
    }
  }, [figureRef, rootRef]);

  var childKey = function childKey(index) {
    return "mgr-child-" + index;
  };

  var renderChildren = function renderChildren() {
    if (!withNav) {
      return react_1.default.createElement(Grid_1.default, {
        container: true,
        justifyContent: "center",
        spacing: 5
      }, react_1.default.Children.map(children, function (child, index) {
        return react_1.default.createElement(Grid_1.default, {
          item: true,
          key: childKey(index),
          onClick: handleSelectChild(child),
          onKeyPress: handleSelectChild(child),
          role: "button",
          tabIndex: 0,
          xs: 5
        }, child);
      }));
    }

    return react_1.default.Children.map(children, function (child, index) {
      return react_1.default.createElement("div", {
        className: "merry-go-round__horse",
        key: childKey(index),
        onClick: handleSelectChild(child),
        onKeyPress: handleSelectChild(child),
        role: "button",
        tabIndex: 0
      }, child);
    });
  };
  /* eslint-disable react/jsx-props-no-spreading */


  return react_1.default.createElement(SideBar_1.default, __assign({}, props, {
    onClose: handleCloseSidebar,
    sidebar: sidebar,
    sideBarContent: currentChild && sideBarContent && sideBarContent(currentChild)
  }), react_1.default.createElement("div", {
    className: "merry_go_round-wrapper",
    style: style,
    ref: rootRef
  }, react_1.default.createElement("div", {
    className: withNav ? 'merry-go-round_figure' : 'merry-go-round_figure-no-nav',
    ref: figureRef
  }, renderChildren()), withNav && react_1.default.createElement("div", {
    className: "merry-go-round-navigation"
  }, react_1.default.createElement(Button_1.default, {
    className: "merry-go-round-navigate merry-go-round-navigate-prev",
    variant: "contained"
  }, react_1.default.createElement(md_1.MdArrowBack, null)), react_1.default.createElement(Button_1.default, {
    className: "merry-go-round-navigate merry-go-round-navigate-next",
    variant: "contained"
  }, react_1.default.createElement(md_1.MdArrowForward, null)))));
};

MerryGoRoundMoment.propTypes = {
  children: prop_types_1.default.arrayOf(prop_types_1.default.element).isRequired,

  /** Determines the background and text color of the `Moment` header. */
  color: prop_types_1.default.shape({
    background: prop_types_1.default.string,
    text: prop_types_1.default.string
  }),

  /** Render function to fill the `SideBar` `Drawer`. */
  sideBarContent: prop_types_1.default.func.isRequired,

  /** Class name for the `SideBar` `Drawer` root. */
  sideBarClassName: prop_types_1.default.string,

  /** Styling object of the moment body container */
  // eslint-disable-next-line react/forbid-prop-types
  style: prop_types_1.default.object,

  /** Paragraph text underneath the title in `Moment` header */
  subtitle: prop_types_1.default.string,

  /** Main heading element of the `Moment` */
  title: prop_types_1.default.node,

  /** The type of `Moment` */
  type: prop_types_1.default.string
};
MerryGoRoundMoment.defaultProps = __assign(__assign({}, constants_1.MOMENT_BASE_DEFAULT_PROPS), {
  layout: constants_1.MomentLayout.MerryGoRound,
  type: constants_1.MomentType.MerryGoRound,
  data: {},
  sideBarContent: function sideBarContent(element) {
    return element;
  },
  style: {}
});
exports.default = MerryGoRoundMoment;